import React, { Fragment, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { currentWidget, setRegPage, showGuestItinerary } from "../../../action/action";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { formatLocalTime, toBool } from "../../JS/utility";
import MiniLoader from "../../UI/MiniLoader";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CMSPath } from "../../../config/constant";


const GuestItinerary = (props) => {

    const { t } = props;
    let room = localStorage.getItem("room");
    const [widgetData, setCurrentWidgetData] = useState({});


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const today = props.serverTimeDate ? new Date(props.serverTimeDate.split("T")[0]) : new Date();
    
        // Clear the time part for comparison
        today.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);
    
        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        const diffInTime = date.getTime() - today.getTime();
        const diffInDays = diffInTime / oneDayInMilliseconds;
    
        if (diffInDays === 0) {
            return "Today";
        } else if (diffInDays === -1) {
            return "Yesterday";
        } else if (diffInDays === 1) {
            return "Tomorrow";
        } else {
            return dateFormatHandler(new Date(dateString).toISOString(), props.dateFormat)
        }
    };

    const handleGoBack = () => {
        props.setGoHome(true)
    }

    const showLoginPopup = () => {
        if (process.env.REACT_APP_INROOMTAB == "true") {
            props.setLoginRequired(true)
        } else {
            props.setRegPage(true);
        }
    }

    const handleShowItineraryDetails = (itinerary) => {
        props.showGuestItinerary(true, itinerary)
    } 

    React.useEffect(() => {

        const guestItineraryWidget = props.widgetList.find((obj) => obj.widgetType == "Guest Itinerary");
        setCurrentWidgetData(guestItineraryWidget);

        if ((!room || room == "null") && !(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) {
            showLoginPopup();
        }

        console.log("Guest Itinerary Data:")
        console.log(props.guest_itinerary)
        console.log(guestItineraryWidget)

    }, [props.guest_itinerary])

    return (
        <Fragment>
            <header className="inner-pages w-footer subpages">
                <a className="button-back" onClick={() => handleGoBack()}></a>
                <div className="heading align-center">
                    <div class="splash-brand">
                        <img src={`${CMSPath}${props.logo}`} />
                    </div>
                </div>
            </header>
            <section id="itinerary" className="widgets padding-top-2">
                <div className="widgets">
                    <div class="widget-header">
                        <div class="widget-header-title">{t('guest_itinerary.heading')}</div>
                        <div class="widget-header-subtitle">{t('guest_itinerary.sub_heading')}</div>
                    </div>

                    <div class="gallery-slides itinerary-list">
                        {
                            ((!room || room == 'null') && !(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))) ?
                                <div class="list-items-container">
                                    <div onClick={showLoginPopup} class="list-item-heading no-reservations">{t('guest_itinerary.login_room')}</div>
                                </div>

                                :

                                props.guest_itinerary.status == "PENDING" || !props.serverTimeDate ?

                                    <MiniLoader />

                                    : props.guest_itinerary.status == "SUCCESS" ?

                                        props.guest_itinerary.payload.length == 0 ?

                                            <div class="list-items-container">
                                                <div class="list-item-heading no-reservations">{t('guest_itinerary.no_reservation_found')}</div>
                                            </div>

                                            :

                                            props.guest_itinerary.payload.map((itineraryGroup) => {
                                                return (
                                                    <div class="list-items-container">
                                                        <div class="list-item-heading">{formatDate(itineraryGroup.itineraryDate)}</div>

                                                        {itineraryGroup.itineraries.map((itinerary) => {
                                                            return (
                                                                <div class="list-item">
                                                                    <div class="list-item-contents">
                                                                        <div class="list-item-name">{itinerary.itineraryName}</div>
                                                                        <div class="list-item-body">{formatLocalTime(new Date((itinerary.itineraryDateTime)), toBool(props.timeFormat))}</div>
                                                                    </div>
                                                                    <div onClick={() => handleShowItineraryDetails(itinerary)} class="list-item-opt">
                                                                        <button>...</button>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            })
                                        :
                                        <div class="list-items-container">
                                            <div class="list-item-heading no-reservations">{t('guest_itinerary.something_went_wrong')}</div>
                                        </div>
                        }
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

GuestItinerary.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        timeFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM : true,
        guest_itinerary: state.store2.guest_itinerary,
    }
}
export default connect(mapStateToProps, { currentWidget, setLoginRequired, setRegPage, setGoHome, showGuestItinerary })(withTranslation('translations')(GuestItinerary));